import React from 'react';

// Reusable skeleton pulse animation
const pulseStyle = {
  background: 'var(--bg-tertiary)',
  borderRadius: 'var(--radius-md)',
  animation: 'skeletonPulse 1.5s ease-in-out infinite',
};

export function SkeletonBlock({ width = '100%', height = 16, style = {} }) {
  return <div style={{ ...pulseStyle, width, height, ...style }} />;
}

export function SkeletonCard({ lines = 3 }) {
  return (
    <div style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-primary)', borderRadius: 'var(--radius-xl)', padding: 'var(--space-xl)', boxShadow: 'var(--shadow-sm)' }}>
      <SkeletonBlock width="60%" height={20} style={{ marginBottom: 12 }} />
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock key={i} width={`${85 - i * 10}%`} height={14} style={{ marginBottom: 8 }} />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 4 }) {
  return (
    <div style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-primary)', borderRadius: 'var(--radius-xl)', padding: 'var(--space-xl)', boxShadow: 'var(--shadow-sm)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 12, marginBottom: 16 }}>
        {Array.from({ length: cols }).map((_, i) => (
          <SkeletonBlock key={i} height={12} width="70%" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 12, padding: '10px 0', borderBottom: '1px solid var(--border-primary)' }}>
          {Array.from({ length: cols }).map((_, j) => (
            <SkeletonBlock key={j} height={14} width={`${60 + Math.random() * 30}%`} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function SkeletonKPICards({ count = 4 }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fit, minmax(160px, 1fr))`, gap: 'var(--space-md)' }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-primary)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-xl)', textAlign: 'center' }}>
          <SkeletonBlock width={40} height={40} style={{ borderRadius: '50%', margin: '0 auto 12px' }} />
          <SkeletonBlock width="70%" height={20} style={{ margin: '0 auto 8px' }} />
          <SkeletonBlock width="50%" height={12} style={{ margin: '0 auto' }} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonDashboard() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-xl)' }}>
      <SkeletonKPICards count={4} />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 'var(--space-xl)' }}>
        <SkeletonCard lines={4} />
        <SkeletonCard lines={3} />
      </div>
      <SkeletonTable rows={5} cols={5} />
    </div>
  );
}

// Add the keyframe animation to App.css
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes skeletonPulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
`;
if (!document.querySelector('#skeleton-styles')) {
  styleSheet.id = 'skeleton-styles';
  document.head.appendChild(styleSheet);
}

export function SkeletonText({ lines = 3, width = "100%" }) {
  return (
    <div>
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock key={i} width={i === lines - 1 ? "60%" : width} height={14} style={{ marginBottom: 8 }} />
      ))}
    </div>
  );
}
